const contactLinks = [
  { icon: "📞", label: "+91 89997 29065", href: "tel:+918999729065" },
  {
    icon: "✉️",
    label: "roshanbhogan007@gmail.com",
    href: "mailto:roshanbhogan007@gmail.com",
  },
  {
    icon: "🔗",
    label: "linkedin.com/in/roshan-bhogan",
    href: "https://linkedin.com/in/roshan-bhogan",
  },
  {
    icon: "💻",
    label: "github.com/ReturnofMatrix",
    href: "https://github.com/ReturnofMatrix",
  },
  {
    icon: "🌐",
    label: "returnofmatrix.github.io/portfolio",
    href: "https://returnofmatrix.github.io/portfolio/",
  },
];

export default function Contact() {
  return (
    <section className="border-t border-surface-border px-5 py-14 pb-20 sm:px-12 sm:py-20 sm:pb-24">
      <h2 className="text-3xl font-bold mb-2 sm:text-4xl sm:mb-3">
        <span className="text-gradient">Contact</span>
      </h2>
      <p className="text-gray-400 mb-8 sm:mb-10 text-sm sm:text-base">Let's connect</p>
      <div className="space-y-4">
        {contactLinks.map((link) => (
          <a
            key={link.href}
            href={link.href}
            target={link.href.startsWith("tel") || link.href.startsWith("mailto") ? undefined : "_blank"}
            rel={link.href.startsWith("tel") || link.href.startsWith("mailto") ? undefined : "noreferrer"}
            className="flex items-center gap-3 rounded-xl border border-surface-border bg-surface-card px-4 py-4 text-gray-300 transition-colors hover:border-accent-cyan/40 hover:text-accent-cyan sm:px-5"
          >
            <span className="text-xl shrink-0">{link.icon}</span>
            <span className="break-all text-sm sm:text-base">{link.label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
